import { render, staticRenderFns } from "./ClientBranches.vue?vue&type=template&id=5320b5eb&scoped=true&"
import script from "./ClientBranches.vue?vue&type=script&lang=js&"
export * from "./ClientBranches.vue?vue&type=script&lang=js&"
import style0 from "./ClientBranches.vue?vue&type=style&index=0&id=5320b5eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5320b5eb",
  null
  
)

export default component.exports